{
 "playnow": {
  "x": 202,
  "y": 1274,
  "w": 578,
  "h": 112
 },
 "tile.profile": {
  "x": 52,
  "y": 1402,
  "w": 276,
  "h": 108
 },
 "tile.join": {
  "x": 340,
  "y": 1402,
  "w": 265,
  "h": 108
 },
 "tile.howto": {
  "x": 616,
  "y": 1402,
  "w": 273,
  "h": 108
 },
 "hud.plus": {
  "x": 780,
  "y": 13,
  "w": 58,
  "h": 59
 },
 "hud.bell": {
  "x": 858,
  "y": 13,
  "w": 68,
  "h": 64
 },
 "hud.credits.pill": {
  "x": 667,
  "y": 13,
  "w": 171,
  "h": 59
 }
}